<template>
  <v-content>
    <keep-alive>
      <component :is="selectedProfileComp"></component>
    </keep-alive>
    

    <!-- <v-bottom-sheet 
      v-if="isMobile"
      v-model="drawer">
      <v-list 
        v-touch="{
          down: () => swipe()
        }"
      
        style="overflow: scroll; height: 90vh; border-top-left-radius: 24px; border-top-right-radius: 24px;"
        class="  ma-0 pa-0"> -->
    <!-- <div style="height: 20px; background-color: rgba(255,255,255,0); opacity: 1;">
        <hr class="menuline">
      </div> -->

    <!-- <v-layout 
        class="py-3 "
        align-center 
        justify-center>
        <hr
          class="menuline"> -->

    <!-- <div 
          style="background-color: red; border: 2px solid lightgrey; border-radius: 10px; width: 72px" /> -->
    <!-- </v-layout> -->
    <app-settings-navigation-drawer></app-settings-navigation-drawer>
    <!-- </v-list>
    </v-bottom-sheet> -->
    <!-- <v-navigation-drawer
      v-else
      v-model="drawer"
      right
      fixed
      temporary
      floating
      clipped
      style="border-top-left-radius: 24px; border-bottom-left-radius: 24px;"> -->
    <!-- Display Profile  -->
    <!-- <app-profile-display v-if="!edit"></app-profile-display> -->

    <!-- Edit Profile -->
    <!-- <app-profile-edit v-if="edit"></app-profile-edit> -->
  <!-- </v-navigation-drawer> -->
  </v-content>
</template>

<script>
import { mapState } from 'vuex'

import SettingsNavigationDrawer from '@/components/View_Profile/SettingsNavigationDrawer'
import ProfileDisplay           from '@/components/View_Profile/ProfileDisplay'
import ProfileEdit              from '@/components/View_Profile/ProfileEdit'
import SettingsGeneral          from '@/components/View_Profile/SettingsGeneral'
import SettingsSecurityLogin    from '@/components/View_Profile/SettingsSecurityLogin'
import SettingsAccount          from '@/components/View_Profile/SettingsAccount'
import SettingsInformation      from '@/components/View_Profile/SettingsInformation'
import SettingsImpressum        from '@/components/View_Profile/SettingsImpressum'
import SettingsDatenschutz      from '@/components/View_Profile/SettingsDatenschutz'
import SettingsVersions         from '@/components/View_Profile/SettingsVersions'
import SettingsToDo             from '@/components/View_Profile/SettingsToDo'
import SettingsFeedback         from '@/components/View_Profile/SettingsFeedback'

export default {
  components: {
    // eslint-disable-next-line
    'app-settings-navigation-drawer': SettingsNavigationDrawer,
    // eslint-disable-next-line
    'app-profile-display': ProfileDisplay,
    // eslint-disable-next-line
    'app-profile-edit': ProfileEdit,
    // eslint-disable-next-line
    'app-profile-settings-general': SettingsGeneral,
    // eslint-disable-next-line
    'app-profile-settings-securitylogin': SettingsSecurityLogin,
    // eslint-disable-next-line
    'app-profile-settings-account': SettingsAccount,
    // eslint-disable-next-line
    'app-profile-settings-information': SettingsInformation,
    // eslint-disable-next-line
    'app-profile-settings-impressum': SettingsImpressum,
    // eslint-disable-next-line
    'app-profile-settings-versions': SettingsVersions,
    // eslint-disable-next-line
     'app-profile-settings-todo': SettingsToDo,
    // eslint-disable-next-line
    'app-profile-settings-datenschutz': SettingsDatenschutz,
    // eslint-disable-next-line
    'app-profile-settings-feedback': SettingsFeedback,

  },

  data() {
    return {
    }
  },
  
  computed: {
    ...mapState({
      selectedProfileComp: state => state.view_profile.selectedProfileComp,
      path: state => state.route.path,
      isMobile: state => state.isMobile
    }),

    
    error () {
      return this.$store.getters.error
    }
   
  },
  beforeMount () {
    this.$store.commit('setSelectedProfileComp', 'app-profile-display')
  },
  
  methods: {
    // toTop() {
    //   window.scrollTo(0, 0)
    // },
    onDismissed () {
      this.$store.dispatch('clearError')
    },

  }
}
</script>

